export default "__VITE_ASSET__BJ31w$hM__"